<template>
  <FieldRowComponent
    :field
    :value="modelValue"
    :rules
    :disabled
    :lockable
    v-slot="{ id, invalid, touch, disabled: inputDisabled }"
  >
    <PhoneNumberInput
      v-if="type === 'tel'"
      :id
      :modelValue
      :countryCode
      :invalid
      @update:modelValue="$emit('update:modelValue', $event)"
      @blur="touch"
    />
    <TextInput
      v-else
      :id
      :type
      :modelValue
      :invalid
      :disabled="inputDisabled"
      @update:modelValue="$emit('update:modelValue', $event)"
      @blur="touch"
    />
  </FieldRowComponent>
</template>

<script setup lang="ts">
import PhoneNumberInput from "@/components/common/PhoneNumberInput.vue";
import type { ValidationRuleCollection } from "@vuelidate/core";
import type { RowFieldKey } from "./fieldKeys";
import FieldRowComponent from "./FieldRowComponent.vue";
import TextInput from "./TextInput.vue";

withDefaults(
  defineProps<{
    field: RowFieldKey;
    modelValue?: string | null;
    rules?: ValidationRuleCollection;
    type?: "text" | "tel" | "email" | "date";
    disabled?: boolean;
    lockable?: boolean;
    /** ISO alpha-2 code a phone number's dial code defaults to. */
    countryCode?: string;
  }>(),
  {
    modelValue: null,
    rules: () => ({}),
    type: "text",
    disabled: false,
    lockable: false,
    countryCode: "",
  }
);

defineEmits<{
  "update:modelValue": [value: string];
}>();
</script>
